import React from 'react';
import { useUiPreferences } from '../../contexts/UiPreferencesContext';

export const ThemeSwitch: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { theme, setTheme } = useUiPreferences();
  return (
    <div className={`theme-switch ${className}`.trim()}>
      <button
        type="button"
        className={theme === 'dark' ? 'on' : ''}
        onClick={() => setTheme('dark')}
        aria-pressed={theme === 'dark'}
      >
        DARK
      </button>
      <button
        type="button"
        className={theme === 'light' ? 'on' : ''}
        onClick={() => setTheme('light')}
        aria-pressed={theme === 'light'}
      >
        LIGHT
      </button>
    </div>
  );
};

export default ThemeSwitch;
